/*
  k27-v3-type: Zeilenumbrüche auf den v3-Seiten.
  Regel (Sandro, 12.10.2026): Ein Satz beginnt nicht am Ende einer Zeile. Passt er nicht mehr
  ganz in die Zeile, beginnt er in der nächsten.
  Umsetzung: Ab dem zweiten Satz eines Absatzes wird jeder Satz in ein <span class="k27-s">
  gesetzt (display:inline-block). Der Browser hält ihn dann zusammen oder beginnt eine neue Zeile.
  Sehr kurze Sätze ("Ja.") bleiben am folgenden Satz, damit sie nicht allein in einer Zeile stehen.
  Geladen von snippets/k27-v3-base.liquid und sections/k27-v3-hero.liquid.
  Ausnahme für einzelne Elemente: Attribut data-no-bind.
*/
(function () {
  if (window.__k27v3type) return;
  window.__k27v3type = true;

  var ROOTS = '.k27v2, .k27.final';
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, SELECT: 1, OPTION: 1, BUTTON: 1, svg: 1 };
  // Nur gewöhnliche Textblöcke. In Flex- und Grid-Kästen wäre jeder Satz ein eigenes Kind.
  var BLOCKS = { block: 1, 'list-item': 1, 'table-cell': 1 };
  var SHORT = 12;
  // Satzende, Leerraum, dann ein Großbuchstabe oder ein öffnendes Anführungszeichen.
  var BREAK = /[.!?…]["“”»«’)]?(\s+)(?=[A-ZÄÖÜ„"«(])/g;

  var style = document.createElement('style');
  style.textContent = '.k27-s{display:inline-block;max-width:100%;vertical-align:baseline;}';
  document.head.appendChild(style);

  function skipped(node, root) {
    for (var p = node.parentNode; p && p !== root.parentNode; p = p.parentNode) {
      if (SKIP[p.nodeName] || (p.hasAttribute && p.hasAttribute('data-no-bind'))) return true;
    }
    return false;
  }

  // Der nächste Vorfahr, der kein Inline-Element ist: der Absatz, in dem der Text umbricht.
  function blockOf(node) {
    for (var el = node.parentNode; el && el.nodeType === 1; el = el.parentNode) {
      var display = getComputedStyle(el).display;
      if (display !== 'inline' && display !== 'contents') return BLOCKS[display] ? el : null;
    }
    return null;
  }

  // Stelle im Gesamttext des Absatzes -> Textknoten und Position darin.
  function locate(parts, pos) {
    for (var i = 0; i < parts.length; i++) {
      if (pos <= parts[i].start + parts[i].node.nodeValue.length) {
        return { node: parts[i].node, offset: pos - parts[i].start };
      }
    }
    return null;
  }

  function onlySpace(container, fromNode, fromOffset, toNode, toOffset) {
    var r = document.createRange();
    r.setStart(fromNode, fromOffset);
    r.setEnd(toNode, toOffset);
    return !/\S/.test(r.toString());
  }

  // Setzt einen Satz in ein Span. Beginnt oder endet er in einem verschachtelten Element
  // (fett, Marker), wird das ganze Element mitgenommen, sofern der Satz es ganz ausfüllt.
  function wrap(block, from, to) {
    var range = document.createRange();
    range.setStart(from.node, from.offset);
    range.setEnd(to.node, to.offset);
    var common = range.commonAncestorContainer;
    if (common.nodeType === 3) common = common.parentNode;
    if (!block.contains(common)) return false;
    // Füllt der Satz ein Inline-Element ganz aus (fett, Marker), kommt das Span außen herum.
    // Sonst läge der Marker bei zwei Zeilen nur auf der letzten.
    while (common !== block &&
      onlySpace(block, common, 0, range.startContainer, range.startOffset) &&
      onlySpace(block, range.endContainer, range.endOffset, common, common.childNodes.length)) {
      range.selectNode(common);
      common = common.parentNode;
    }
    var s = range.startContainer;
    while (s !== common && s.parentNode !== common) {
      var sp = s.parentNode;
      if (!onlySpace(block, sp, 0, range.startContainer, range.startOffset)) return false;
      range.setStartBefore(sp);
      s = sp;
    }
    var e = range.endContainer;
    while (e !== common && e.parentNode !== common) {
      var ep = e.parentNode;
      if (!onlySpace(block, range.endContainer, range.endOffset, ep, ep.childNodes.length)) return false;
      range.setEndAfter(ep);
      e = ep;
    }
    var span = document.createElement('span');
    span.className = 'k27-s';
    try {
      range.surroundContents(span);
    } catch (err) {
      return false;
    }
    return true;
  }

  function fixBlock(block, nodes) {
    var text = '';
    var parts = nodes.map(function (node) {
      var part = { node: node, start: text.length };
      text += node.nodeValue;
      return part;
    });
    // Satzgrenzen: Ende des einen Satzes und Anfang des nächsten.
    var cuts = [];
    var m;
    BREAK.lastIndex = 0;
    while ((m = BREAK.exec(text))) {
      cuts.push({ end: m.index + m[0].length - m[1].length, start: m.index + m[0].length });
    }
    if (!cuts.length) return;
    // Sätze als [Anfang, Ende]. Der erste beginnt am Absatzanfang und bleibt, wie er ist.
    var sentences = [];
    for (var i = 0; i < cuts.length; i++) {
      var end = i + 1 < cuts.length ? cuts[i + 1].end : text.replace(/\s+$/, '').length;
      sentences.push({ start: cuts[i].start, end: end, prevStart: i ? cuts[i - 1].start : 0, prevEnd: cuts[i].end });
    }
    // Von hinten nach vorn, damit die Positionen davor gültig bleiben.
    for (var k = sentences.length - 1; k >= 0; k--) {
      var sen = sentences[k];
      // Ein sehr kurzer Satz davor bleibt an diesem Satz hängen.
      if (sen.prevEnd - sen.prevStart < SHORT) continue;
      // Ein sehr kurzer Satz nimmt den folgenden mit.
      var endPos = sen.end;
      if (sen.end - sen.start < SHORT && k + 1 < sentences.length) endPos = sentences[k + 1].end;
      var from = locate(parts, sen.start);
      var to = locate(parts, endPos);
      if (from && to) wrap(block, from, to);
    }
  }

  function fix(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var blocks = [];
    var lists = [];
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || skipped(node, root)) continue;
      var block = blockOf(node);
      if (!block) continue;
      var at = blocks.indexOf(block);
      if (at < 0) { blocks.push(block); lists.push([node]); } else lists[at].push(node);
    }
    blocks.forEach(function (block, i) { fixBlock(block, lists[i]); });
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOTS), function (root) {
      // Verschachtelte Bereiche nur einmal bearbeiten.
      if (root.parentNode && root.parentNode.closest && root.parentNode.closest(ROOTS)) return;
      fix(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
